import { useApiMutationCampaignFirebaseKey } from '@hooks-api/fortune/useApiCampaignFirebaseKey'
import { type DataSnapshot } from 'firebase/database'
import { useEffect, useState } from 'react'
import { firebaseObserver } from '../utils/firebaseObserver'

interface UseFirebaseOrderProps {
  code?: string
  orderHash?: string
}

interface FirebaseOrderSnapshot {
  payment_transaction_id: number
  updated_at: number
}

export const useFirebaseOrder = (props: UseFirebaseOrderProps) => {
  const { code, orderHash } = props
  const { trigger } = useApiMutationCampaignFirebaseKey()
  const [updatedAt, setUpdatedAt] = useState<number>()

  useEffect(() => {
    if (!code || !orderHash) return
    const fetchFirebaseKey = async () => {
      const { data } = await trigger({
        code,
        order_hash: orderHash,
      })
      const key = data.data.firebase_key
      firebaseObserver.subscribe(
        `orders/${key}`,
        (snapshot: DataSnapshot) => {
          const value: FirebaseOrderSnapshot = snapshot.val()
          if (value) {
            setUpdatedAt(value.updated_at)
          }
        },
      )
    }
    fetchFirebaseKey()
    return () => {
      firebaseObserver.unsubscribe()
    }
  }, [code, orderHash, trigger])

  return {
    updatedAt,
  }
}
